<script setup lang="ts">
useCacheRoute()
</script>

<template>
  <div v-track="{ id: 'web-privacy', view: { value: { page: 'other-privacy' } } }" class="content">
    <h1 class="title">
      Privacy Policy
    </h1>
    <p>
      JUST OKAY (JUST OKAY LIMITED) recognizes the
      importance of protecting your privacy so we have developed a Privacy
      Policy that covers how we collect, use, disclose, transfer, and
      store your personal information. This Privacy Policy describes our
      general privacy practices that apply to personal information we
      collect, use and share about users and other individuals within our
      clients, business partners, supplier and other organizations with
      which we have or contemplate a business relationship.
    </p>
    <h2>Why we collect and use your personal information</h2>
    <p>
      You may be asked to provide your personal information anytime you
      are in contact with us. JUST OKAY and its affiliates may share this
      personal information with each other and use it consistent with this
      Privacy Policy. They may also combine it with other information to
      provide and improve our products, services, content, and
      advertising. You are not required to provide the personal
      information that we have requested, but, if you chose not to do so,
      in many cases we will not be able to provide you with our products
      or services or respond to any queries you may have.
    </p>
    <h2>What personal information we collect</h2>
    <ul>
      <li>IP address</li>
      <li>Internet service provider (ISP)</li>
      <li>Operating system</li>
      <li>Date/time stamp</li>
      <li>Clickstream data</li>
      <li>Location information</li>
      <li>Device identifiers</li>
      <li>Browser settings</li>
      <li>
        Browser cookies and other technologies such as pixel tags and
        web beacons
      </li>
      <li>App activity such as app installation, app uninstallation</li>
      <li />
    </ul>

    <h2>How we use your personal information</h2>
    <ul>
      <li>
        We may process your personal information: for the purposes
        described in this Privacy Policy, with your consent, for
        compliance with a legal obligation to which JUST OKAY is subject
        or when we have assessed it is necessary for the purposes of the
        legitimate interests pursued by JUST OKAY or a third party to whom
        it may be necessary to disclose information.
      </li>
      <li>
        We also use personal information to help us create, develop,
        operate, deliver, and improve our products, services, content
        and advertising, and for loss prevention and anti-fraud
        purposes. We may also use your personal information for network
        security purposes.
      </li>
      <li>
        We may also use personal information for internal purposes such
        as auditing, data analysis, and research to improve JUST OKAY’s
        products, services, and user communications.
      </li>
      <li>
        JUST OKAY’s websites, applications, and advertisements may use
        "cookies" and other technologies such as pixel tags and web
        beacons. These technologies help us better understand user
        behavior, tell us which parts of our websites people have
        visited, and facilitate and measure the effectiveness of
        advertisements and web searches.
      </li>
      <li>
        As is true of most internet services, we gather some information
        automatically and store it in log files. This information
        includes Internet Protocol (IP) addresses, browser type and
        language, Internet service provider (ISP), referring and exit
        websites and applications, operating system, date/time stamp,
        and clickstream data. We use this information to understand and
        analyze trends, to administer the site, to learn about user
        behavior on the site, to improve our product and services, and
        to gather demographic information about our user base as a
        whole. JUST OKAY may use this information in our marketing and
        advertising services.
      </li>
    </ul>
    <h2>Information Security and Accuracy</h2>
    <p>
      We intend to protect your personal information and to maintain its
      accuracy. JUST OKAY implements reasonable physical, administrative and
      technical safeguards to help us protect your personal information
      from unauthorized access, use and disclosure. For example, we
      encrypt certain sensitive personal information when we transmit such
      information over the Internet.
    </p>
    <h2>How to contact us</h2>
    <p>
      If you have any questions related to this Privacy Policy, please
      contact us via support@ldplayer.net
    </p>
    <h2>Changes to our Privacy Policy</h2>
    <p>
      We may update this Privacy policy from time to time. When making
      changes to this Privacy Policy, we will add a new date at the top of
      this Privacy Policy.
    </p>
  </div>
</template>

<style lang="scss" scoped>
.content {
  margin-left: auto;
  margin-right: auto;
  max-width: 1440px;
  padding: 80px;

  .title {
    font-size: 26px;
    font-weight: 700;
    text-align: center;
    margin: 0 auto 60px;
    padding: 60px 0;
    border-bottom-width: 1px;
    border-color: #eaeaea;
    border-style: solid;
  }

  p {
    font-size: 14px;
    line-height: 24px;
    color: #666;
    margin-bottom: 25px;
  }

  ul {
    margin-bottom: 25px;
  }

  li {
    font-size: 14px;
    line-height: 24px;
    color: #666;
    margin-inline-start: 20px;
    list-style-type: disc;
  }

  h2 {
    font-size: 16px;
    line-height: 28px;
    font-weight: 700;
    margin: 0;
    margin-bottom: 5px;
  }
}

/* layer: default */
@media (max-width: 767.9px) {
  .content {
    padding: 20px;

    .title{
      margin: 0 auto 20px;
      padding: 20px 0;
    }
  }
}
</style>
